module.exports = __webpack_public_path__ + "img/align_justify.c402cf67.svg";